import styled, { css } from 'styled-components';
import { sidenavTokens } from './tokens';

export const OutlineStyles = css`
  &:focus-visible {
    outline: 2px solid #176bb8;
    outline-offset: -2px;
  }
`;

export const ResetButton = css`
  background-color: transparent;
  border: none;
`;

export const StyledSideNavList = styled.ul`
  width: 100%;
`;

export const StyledSideNavLogoWrapper = styled.div`
  margin-left: 16px;
  margin-top: 30px;
  margin-bottom: 40px;
  padding-left: ${sidenavTokens.WrapperPaddingLeftBaseDefault};
  padding-right: ${sidenavTokens.WrapperPaddingRightBaseDefault};
`;

export interface StyledSideNavWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  isCompact: boolean;
  isMobile?: boolean;
}

export const StyledSideNavWrapper = styled.div<StyledSideNavWrapperProps>`
  height: 100%;

  ${({ isMobile, isCompact }) =>
    isCompact &&
    css`
      width: ${sidenavTokens.WrapperWidthBaseClosed};

      ${isMobile &&
      css`
        width: 0;
      `}
    `}
`;

export type StyledSideNavProps = {
  $width?: string;
  isCompact: boolean;
  isMobile?: boolean;
  isActive?: boolean;
  hideFilter?: boolean;
};

export const StyledSideNav = styled.nav<StyledSideNavProps>`
  background-color: ${sidenavTokens.WrapperColorBackgroundBaseDefault};
  font-family: var(--text-sans);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: start;
  overflow-x: hidden;
  transition: ${`width ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          padding ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  padding: ${({ hideFilter }) =>
    hideFilter
      ? css`
          ${sidenavTokens.WrapperPaddingTopBaseOpen} 0 0 0
        `
      : css`
          ${sidenavTokens.WrapperPaddingTopBaseOpen} 0 0 0
        `};
  width: ${({ $width, isMobile }) => {
    if ($width) {
      return $width;
    }
    return isMobile ? sidenavTokens.WrapperWidthMobileOpen : sidenavTokens.WrapperWidthBaseOpen;
  }};

  @media print {
    display: none;
  }

  ${({ isCompact }) =>
    isCompact &&
    css`
      position: absolute;
      z-index: ${sidenavTokens.WrapperElevationCompactDefault};
    `}
`;
